import { render, staticRenderFns } from "./TransactionsAdmin.vue?vue&type=template&id=4098a5f7&scoped=true&"
import script from "./TransactionsAdmin.vue?vue&type=script&lang=js&"
export * from "./TransactionsAdmin.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4098a5f7",
  null
  
)

export default component.exports